export default "__VITE_ASSET__Sem7oDMH__"